import { useEffect } from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../consts/routes';
import { useAdminCardDecksServers } from '@olagg/api-hooks';
import ServerForm from './Form';
import { CreateCardDeckServerData } from '@olagg/db-types';
import { Center, VStack, Spinner, Heading } from '@chakra-ui/react';

export const EditServer = () => {
  const navigate = useNavigate();
  const { deck_id, id } = useParams();

  if (!deck_id || !id) return null

  const { updateServer, find, server, isLoading } = useAdminCardDecksServers(deck_id);
  
  useEffect(() => {
    if (id) find(id);
  }, [id]);

  if (isLoading) return <Spinner>Cargando...</Spinner>

  const handleSubmit = async (data: CreateCardDeckServerData) => {
    await updateServer(id, data);
    navigate(generatePath(ROUTES.CARD_DECKS.servers.all, { deck_id }));
  };

  if (!server) return null;

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>
          Editar Servidor de Discord
        </Heading>
        <ServerForm onSubmit={handleSubmit} server={server} />
      </VStack>
    </Center>
  );
};
